var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ColumnLayout',{staticClass:"password"},[(_vm.passwordIcon)?_c('template',{slot:"left"},[_c('div',{staticClass:"text-right"},[_c('img',{attrs:{"src":require("assets/images/password/icon.svg"),"alt":"Password"}})])]):_vm._e(),_c('template',{slot:"right"},[_c('router-view')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }